import React, { Fragment, useState, useEffect } from 'react';
import { LogIn, ArrowLeftCircle, Calendar, Bell, X } from 'react-feather';
import { useNotification } from '../../hooks/notification/useNotification';
import { Button, Col } from 'reactstrap'
import { Sidebar } from "primereact/sidebar";
import { FormNotification } from '../../components/notifications/formNotification';
import { useGlobalNotifications } from '../../hooks/notification/useglobalNotifications';
import { ModalSearch } from './ModalSearch';
import { getAllNim } from '../../services/notification/notificatiosService.'
import { useSweetAlert } from '../../hooks/sweetAlerts/useSweetAlert';
import '../header/Notifications.css';
import { GlobalSearch } from '../../components/globalSearch/GlobalSearch';
import { ComponentReload } from '../../components/tableDataTable/ComponentReload';




import {
  setTranslations,
  setDefaultLanguage,
  setLanguageCookie,
  setLanguage,
  translate,
} from 'react-switch-lang';


import en from '../../assets/i18n/en.json';
import es from '../../assets/i18n/es.json';
import pt from '../../assets/i18n/pt.json';
import fr from '../../assets/i18n/fr.json';
import du from '../../assets/i18n/du.json';
import cn from '../../assets/i18n/cn.json';
import ae from '../../assets/i18n/ae.json';
import { useHistory } from 'react-router-dom';
import { ConfigServer } from '../../data/config';
import { Color } from 'highcharts';

setTranslations({ en, es, pt, fr, du, cn, ae });
setDefaultLanguage('en');
setLanguageCookie();


const Rightbar = (props) => {
  const [moonlight, setMoonlight] = useState(false)
  const [find, setFind] = useState(false)
  const history = useHistory();
  const [notificationDropDown, setNotificationDropDown] = useState(false)
  const [createSweet] = useSweetAlert();


  useEffect(() => {
    if (localStorage.getItem("layout_version") === "dark-only") {
      setMoonlight(true)
      setTimeout(() => {
        document.body.className = "dark-only";
      }, 100);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("finance_view") === "False") {
      setFind(true)
    }
  }, []);

  //*CONFIGURATION MOONLIGHT
  const MoonlightToggle = (light) => {
    if (light) {
      setMoonlight(!light)
      document.body.className = "light"
      localStorage.setItem('layout_version', 'light');
    } else {
      setMoonlight(!light)
      document.body.className = "dark-only"
      localStorage.setItem('layout_version', 'dark-only');
    }
  }

  //*CONFIGURATION FINANCE
  //!VARIABLES GLOBALES
  let _finance = localStorage.getItem('finance');
  let _admin_finance = localStorage.getItem('admin_finance');
  let _configuration_role = localStorage.getItem('configuration_role');

  const UserMenuRedirect = (redirect) => {
    history.push(redirect)
  }

  //*CONFIGURATION LOG OUT
  const cerrarSesion = () => {
    let url = localStorage.getItem("url_helen");
    localStorage.clear();

    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(url + "/logout", requestOptions)
      .then(response => response.text())
      .then(result => {
        setTimeout(() => {
          window.location.href = url;
        }, 500);
      })
      .catch(error => console.log('error', error));
  }

  //*CONFIGURATION LOG OUT HELEN
  const backToHELEN = () => {
    let username = localStorage.getItem("username");
    let base64 = btoa(username);
    let url = localStorage.getItem("url_helen");
    window.location.href = url + "/validacionHtds/" + base64;
  }

  //*CONFIGURATION FINANCE
  const financeMethod = (light) => {
    if (light) {
      setFind(!light)

      localStorage.setItem("financeView", "False");
      localStorage.setItem("finance_view", "True");
      window.location.href = `${process.env.PUBLIC_URL}/dashboard/default`


    } else {
      setFind(!light)
      localStorage.setItem('finance_view', 'False');
      window.location.href = `${process.env.PUBLIC_URL}/dashboard/default`

    }
  }


  // ? CONFIGURATION SEARCH CAPTURE RESULT 
  const [modalSearch, setModalSearch] = useState(false);
  const [nim, setNim] = useState("");
  const [cancelledMessage, setCancelledMessage] = useState(false);


  const toggleModalSearch = () => {
    setModalSearch(!modalSearch);

    if (modalSearch) {
      setCancelledMessage(false);
    }
  }

  const handleSearch = () => {
    toggleModalSearch()
  }


  const handleInputChange = (e) => {
    setNim(e.target.value);
  };



  const searchNim = async () => {
    if (nim === "") {
      createSweet("create", "warning", "Busqueda", "Debe agregar un nim para realizar la busqueda");
      setCancelledMessage(false);
      setNim("")
      return;
    }

    const searchNim = await getAllNim(nim);
    console.log("🚀 ~ searchNim ~ searchNim:", searchNim)
    if (searchNim.code === 200) {
      if (searchNim.data.length > 0) {
        searchNim.data.forEach(_find => {
          if (_find.id_status === 20) {
            setCancelledMessage(true);
            setNim("");
            return;
          } else {
            setCancelledMessage(false);
          }

          if (_find?.is_micro) {
            window.location.replace(`../../captura-resultados-sanitaria/${_find.nim}`);

            setNim("")
          }
          else {
            window.location.replace(`../../captura-resultados/${_find.nim}`);

            setNim("")
          }
          toggleModalSearch()
        });
      } else {
        createSweet("create", "warning", "Busqueda", "No existe este nim, verifique que se encuentre en el sistema");
        setNim("")
        setCancelledMessage(false);
      }
    }
    else {
      setNim("")
      createSweet("create", "warning", "Busqueda", "Debe escribir un nim");
      setCancelledMessage(false);
    }
  }








  const [nameUser, setNameUser] = useState("User");
  const [roleUser, setRoleUser] = useState("Normal")

  useEffect(() => {
    localStorage.getItem("nameUser") !== null && setNameUser(localStorage.getItem("nameUser").toUpperCase());
    localStorage.getItem("roleUser") !== null && setRoleUser(localStorage.getItem("roleUser").toUpperCase());
  }, []);

  //*NOTIFICATIONS
  const { navigateUpdate, notificationInvoices } = useNotification();

  const [visibleRight, setVisibleRight] = useState(false);

  const {

    sections,
    unreadCount,
    removeNotification,
    fetchUnreadCount,

    setHoveredId,
    hoveredId,
    handleNotificationAction,
    removeSectionNotifications,
    
  } = useGlobalNotifications();
  const admin_cash = localStorage.getItem("admin_cash");

      // console.log("🫒 sections", sections);

  const canSeeNotifications =
    (_finance === "True" && _configuration_role === "True" && _admin_finance === "True")
    || admin_cash === "True";

  const [openSections, setOpenSections] = useState({});

  const toggleSection = (sectionName) => {
    setOpenSections(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName]
    }));
  };

  return (
    <Fragment>

      <div className="nav-right col-8 pull-right right-header p-0 text-white">
        {/* <div className="nav-right col-4 pull-right right-header p-0 text-white"> */}

        <ul className="nav-menus">
         {/* <li style={{ width: "350px" }}>
            <GlobalSearch
              onSelect={(item) => {
                window.location.replace(`../../captura-resultados/${item.nim}`);
              }}
            />
          </li> */}
          <li className="li-global-search">
           <GlobalSearch
              onSelect={(item) => {
                if (item.is_micro) {
                  window.location.replace(`../../captura-resultados-sanitaria/${item.nim}`);
                } else {
                  window.location.replace(`../../captura-resultados/${item.nim}`);
                }
              }}
            />

          </li>
           {/* <li>
            <div className="mode text-white" onClick={handleSearch} ><i className={`icofont icofont-search-alt-1`}></i>
            </div>
         
          </li> */}
        
          <li>
            <div className="mode text-white" onClick={() => MoonlightToggle(moonlight)}><i className={`fa ${moonlight ? 'fa-lightbulb-o' : 'fa-moon-o'}`}></i></div>
          </li>
          <li>
            {
              _finance === "True" &&
              _configuration_role === "True" &&
              _admin_finance === "True" &&
              <div className="mode text-white" onClick={() => financeMethod(find)} ><i className={`icofont ${find ? 'icofont-restaurant-search ' : 'icofont-search-alt-1'}`}></i>
              </div>}

          </li>
          <li className='mode pl-0 pr-0' >

            <ComponentReload />


          </li>
          
          {canSeeNotifications && (
            <li className="profile-nav onhover-dropdown p-0">
              <div
                onClick={() => setVisibleRight(true)}
                className="cursor-pointer"
              >
                <div className="notification-box text-white">
                  <Bell />
                  <span className="badge badge-pill badge-danger">
                    {unreadCount}
                  </span>

                </div>
              </div>
            </li>
          )}

         <Sidebar
          visible={visibleRight}
          closeOnEscape={true}
          position="right"
          onHide={() => setVisibleRight(false)}
          modal={false}
          showCloseIcon={false}
          style={{
            background: 'rgba(39, 127, 168, 0.3)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
            width: '29%'
          }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="text-lg font-semibold mb-0" style={{ color: '#000000' }}>
              <b className='b-notification'>Notificaciones</b>
            </h5>
          </div>

          <hr />

          {sections.length === 0 && (
            <p className="text-center text-gray-500">
              No hay notificaciones
            </p>
          )}

         {sections.map(section => {
          const isOpen = openSections[section.section];
          const visibleNotifications = isOpen
            ? section.notifications
            : section.notifications.slice(0, 1);
            const unreadCountSection = section.notifications.filter(n => !n.read).length;

            return (
              <Fragment key={section.section}>
                <h6
                  className="d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    toggleSection(section.section);
                  }}

                >
                  <b className='b-notification' style={{ color: '#000000' }}>{section.section}</b>
                  <div className="d-flex align-items-center gap-2">
                  
                        {![2].includes(section.id_section) && (
                          <Button
                            color="danger"
                            size="sm"
                            style={{
                              padding: "3px 6px",
                              height: "24px",
                              fontSize: "0.8rem",
                              borderRadius: "6px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#fff"
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              removeSectionNotifications(section.section);
                            }}
                            title="Borrar todas las notificaciones"
                            className='mr-1'
                          >
                            <i className="fa fa-trash"></i>
                          </Button>
                        )}


                      {unreadCountSection > 1 && (
                        <span className="badge"  style={{ background: "#0663bf", color: "#fff" }}>
                          {unreadCountSection}
                        </span>
                        
                      )}
                    </div>
                </h6>

                <div style={{ position: "relative" }}>
                  
                  {/* STACK VISUAL */}
                  {!isOpen && section.notifications.length > 1 && (
                    <>
                      <div className="stack-indicator stack-1" />
                      <div className="stack-indicator stack-2" />
                    </>
                  )}

                  <FormNotification
                    notifications={visibleNotifications}
                    hoveredId={hoveredId}
                    setHoveredId={setHoveredId}
                    removeNotification={removeNotification}
                    icon={section.icon}
                    handleNotificationAction={handleNotificationAction}
                  />
                </div>

                {/* VER MÁS */}
                {!isOpen && section.notifications.length > 1 && (
                  <div
                    className="text-center text-primary mt-3"
                    style={{ fontSize: "12px",  cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      toggleSection(section.section);
                    }}

                  >
                    <i className="fa fa-chevron-down"></i> Ver más
                  
                  </div>
                )}

                {/* OCULTAR */}
                {isOpen && section.notifications.length > 1 && (
                  <div
                    className="text-center text-primary mt-2"
                    style={{ fontSize: "12px",  cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    toggleSection(section.section);
                  }}

                  >
                    <i className="fa fa-chevron-up"></i> Ocultar
                  </div>
                )}

                <hr />
              </Fragment>
            );
          })}


        </Sidebar>
          <li className='p-t-0 p-b-0' >
            <div className="media profile-media">
              <img className="b-r-10  "
                src={ConfigServer.serverUrl + "/api/Configuration/Logo"}
                style={{ width: "100%" }}
                alt="" />
            </div>
          </li>
          <li className="profile-nav onhover-dropdown p-0">
            <div>
              <div className="media-body p-2 text-white"><span>{nameUser} <i className="middle fa fa-angle-down"></i> <br />  </span>
              </div>
            </div>
            <ul className="profile-dropdown onhover-show-div">
              {
                _finance === "True" &&
                _configuration_role === "True" &&
                _admin_finance === "True" &&
                <li onClick={() => UserMenuRedirect(`${process.env.PUBLIC_URL}/visualizador/calender`)}  ><Calendar /><span>{"Configuración"}</span></li>
              }
               <li onClick={backToHELEN}><ArrowLeftCircle />
                <span>HELEN</span>
              </li>
              <li onClick={cerrarSesion}><LogIn /><span>Cerrar sesión</span></li>
            </ul>
          </li>
        </ul>
      </div>
      {
        <ModalSearch
          {
          ...{
            modalSearch, toggleModalSearch, searchNim, handleInputChange, nim, cancelledMessage
          }
          }

        />

      }

    </Fragment>
  );
}
export default translate(Rightbar);